import { defineComponent as h, computed as d, createBlock as y, openBlock as l, resolveDynamicComponent as b, normalizeStyle as x, withCtx as z, createElementBlock as N } from "vue";
import { KUI_ICON_SIZE_50 as c } from "./kong-icons.es1487.js";
const w = ["aria-hidden"], u = '<path d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z" fill="currentColor"/>', q = /* @__PURE__ */ h({
  __name: "MenuIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: c,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (i) => {
        if (typeof i == "number" && i > 0)
          return !0;
        if (typeof i == "string") {
          const e = String(i).replace(/px/gi, ""), n = Number(e);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const e = i, n = d(() => {
      if (typeof e.size == "number" && e.size > 0)
        return `${e.size}px`;
      if (typeof e.size == "string") {
        const r = String(e.size).replace(/px/gi, ""), t = Number(r);
        if (t && !isNaN(t) && Number.isInteger(t) && t > 0)
          return `${t}px`;
      }
      return c;
    }), g = d(() => ({
      boxSizing: "border-box",
      color: e.color,
      display: e.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: e.decorative ? "none" : void 0
    })), p = (r) => {
      const t = {}, S = Math.random().toString(36).substring(2, 12);
      return r.replace(/id="([^"]+)"/g, (s, o) => {
        const a = `${S}-${o}`;
        return t[o] = a, `id="${a}"`;
      }).replace(/#([^\s^")]+)/g, (s, o) => t[o] ? `#${t[o]}` : s);
    }, f = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, m = (r) => r.replace(/[<>"'&]/g, (t) => f[t]), v = `${e.title ? `<title data-testid="kui-icon-svg-title">${m(e.title)}</title>` : ""}${e.staticIds ? u : p(u)}`;
    return (r, t) => (l(), y(b(i.as), {
      "aria-hidden": i.decorative ? "true" : void 0,
      class: "kui-icon menu-icon",
      "data-testid": "kui-icon-wrapper-menu-icon",
      style: x(g.value),
      tabindex: i.decorative ? "-1" : void 0
    }, {
      default: z(() => [
        (l(), N("svg", {
          "aria-hidden": i.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-menu-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: v
        }, null, 8, w))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
});
export {
  q as default
};
//# sourceMappingURL=kong-icons.es830.js.map
